import React from 'react';
import {withRouter} from "react-router-dom";
import {Carousel, Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {useTranslation} from "react-i18next";

// CSS Files
import './styles.css';

const RegistrationInfoModal = (props) => {
   const { t } = useTranslation();

   return <Modal show={props.show} onHide={props.handleClose} centered>
      <Modal.Body>
         <h3 className={"mb-4"}>{t("registrations_page.info_modal.title")}</h3>
         <Carousel interval={null}>
            <Carousel.Item>
               <p>{t("registrations_page.info_modal.info1")}</p>
            </Carousel.Item>
            <Carousel.Item>
               <p>{t("registrations_page.info_modal.info2")}</p>
               <p>{t("registrations_page.info_modal.info3")}</p>
            </Carousel.Item>
            <Carousel.Item>
               <p>{t("registrations_page.info_modal.info4")}</p>
               <p>{t("registrations_page.info_modal.info5")}</p>
            </Carousel.Item>
            <Carousel.Item>
               <p>{t("registrations_page.info_modal.info6")}</p>
            </Carousel.Item>
         </Carousel>
         <Button onClick={props.handleClose} className="w-100 btn-thick" variant={"secondary"}>{t("common.close")}</Button>
      </Modal.Body>
   </Modal>
};

export default withRouter(RegistrationInfoModal);
